module.exports = __webpack_public_path__ + "img/Icono-final-3.64025fde.png";